import { BackForwardControl } from "@circleco/compass/components/BackForwardControl";

import { t } from "@/i18n-js/instance";

import { useCanvasHistoryNav } from "./CanvasHeaderContext";

export const CanvasHistoryNav = () => {
  const { canGoBack, canGoForward, goBack, goForward } = useCanvasHistoryNav();

  return (
    <BackForwardControl
      // Compass pins this control with `self-start`. The canvas header row
      // centers siblings, so override that when a taller left action (tabs,
      // segmented control) stretches the row.
      className="self-center"
      back={{
        onClick: goBack,
        disabled: !canGoBack,
        label: t("circle_ai_shell.canvas_header.go_back"),
      }}
      forward={{
        onClick: goForward,
        disabled: !canGoForward,
        label: t("circle_ai_shell.canvas_header.go_forward"),
      }}
    />
  );
};

CanvasHistoryNav.displayName = "CanvasHistoryNav";
